import React from 'react';
import {Chip} from '@mui/material';
import {GridColDef} from '@mui/x-data-grid';
import {FDataGrid} from '../grid';
import {BudgetValidationIssueRow} from './budgetvalidation.models';

type Props={rows:BudgetValidationIssueRow[];loading?:boolean;onRoute:(row:BudgetValidationIssueRow)=>void;active:boolean};
export default class BudgetValidationIssueGrid extends React.PureComponent<Props>{
  private columns=():GridColDef[]=>[
    {field:'severitycode',headerName:'Severity',width:110,renderCell:p=><Chip size="small" label={p.value} color={p.value==='BLOCKING'?'error':p.value==='WARNING'?'warning':'info'}/>},
    {field:'issueclasscode',headerName:'Class',width:145},
    {field:'title',headerName:'Finding',minWidth:240,flex:1},
    {field:'description',headerName:'Details',minWidth:300,flex:1},
    {field:'amount',headerName:'Amount',width:140,type:'number'},
    {field:'targetlabel',headerName:'Return To',width:190,cellClassName:'target'},
    {field:'resolved',headerName:'Resolved',width:100,type:'boolean'},
  ];
  render(){return <FDataGrid title="Validation Findings & Routing" subtitle="Each issue identifies the module that owns its correction." rows={this.props.rows} columns={this.columns()} loading={this.props.loading} height={340} getRowId={(r:any)=>r.id} selectionMode="single" onSelectedRowChange={(row:any)=>{if(row&&this.props.active)this.props.onRoute(row)}} sx={{'& .target':{bgcolor:'warning.lighter',fontWeight:600}}}/>;}
}
